import app from 'flarum/common/app';

app.initializers.add('mattoid/flarum-ext-store-check-in', () => {
  console.log('[mattoid/flarum-ext-store-check-in] Hello, forum and admin!');
});
